/**
 * Tower Construction Progress, the HUD's demo analysis (ported from the production Widget Host): a synthetic
 * north-to-south construction schedule over the CURRENT tower positions. The schedule is illustrative; the positions
 * and the count are the published alignment, so they move when it does. Pure, tested in Node.
 */
import { accentHex } from '../accent';
import { METER_TICKS } from './engine';

export const DAY_MS = 86_400_000;
/** A built tower: the project accent (production's 14 Oct change from a fixed green), read when it is drawn. */
export const towerDone = (): string => accentHex();
export const TOWER_TODO = '#8a949c';

/** A published tower: where it stands, and its name and line for the popup ('' where the layer has none). */
export interface TowerSite {
  lngLat: [number, number];
  name: string;
  line: string;
}

export interface ScheduledTower extends TowerSite {
  /** Days after the schedule start this tower is built. */
  day: number;
}

/** Northernmost first, spread evenly over the schedule's days. */
export function scheduleTowers(sites: readonly TowerSite[], days: number): ScheduledTower[] {
  const rows = sites.slice().sort((a, b) => b.lngLat[1] - a.lngLat[1]);
  const n = rows.length;
  return rows.map((t, i) => ({ ...t, day: n > 1 ? Math.round((i / (n - 1)) * days) : 0 }));
}

export const towersDone = (towers: readonly ScheduledTower[], day: number): number =>
  towers.reduce((s, t) => s + (t.day <= day ? 1 : 0), 0);

/** Where the slider starts: 40% of the way through. */
export const initialTowerDay = (days: number): number => Math.round(days * 0.4);

export const fmtTowerDate = (ms: number): string =>
  new Date(ms).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });

/** The date meter's ticks: lit up to the fraction of the schedule elapsed. */
export function towerTicks(frac: number): { bg: string; h: number }[] {
  return Array.from({ length: METER_TICKS }, (_, i) => ({
    bg:
      i / METER_TICKS <= frac ? 'color-mix(in srgb,var(--mm-accent,#27e3c4) 60%,transparent)' : 'rgba(255,255,255,.16)',
    h: 6 + (i / METER_TICKS) * 8,
  }));
}
